import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit, Input, HostListener, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ADPResourceService } from 'digital-core';
import { ChatHandler } from 'src/app/core/handler/chat-handler';
import { AsappChatService } from 'src/app/core/services/asapp-chat.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { IFaqListItemKeys } from 'src/app/model/sitefinity/IFaq';

@Component({
  selector: 'pgh-p360-faq',
  templateUrl: './p360-faq.component.html',
  styleUrls: ['./p360-faq.component.scss'],
})
export class FaqP360Component implements OnInit {
  faqListItems: IFaqListItemKeys[];
  faqNavKeys = [];
  faqNavMenu = [];
  currentlyOpenedItemIndex = -1;
  selectedNavKey: string;
  selectedNavItem: string;
  isMobile = false;
  viewLabel: string;
  selectedNavItemTitle: string;

  faqReplacementDeviceP360Answer3Key: string = "FAQ_ReplacementDevice_P360_Answer_3";

  private storageService = inject(StorageService);
  private matDialog: MatDialog = inject(MatDialog);
  private utilityService: UtilityService = inject(UtilityService);
  private asappChatService = inject(AsappChatService);

  private chatHandler: ChatHandler;

  isSPOEEnabled: boolean = false;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private resourceService: ADPResourceService,
    public route: ActivatedRoute,
  ) {
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.isMobile = window.innerWidth < 992;
  }

  ngOnInit(): void {
    this.isSPOEEnabled = this.resourceService.isPortalSettingTrue("Global_SPOE_Enabled");
    if(this.isSPOEEnabled){
         this.chatHandler = new ChatHandler(this.matDialog, this.resourceService, this.utilityService, this.route, this.asappChatService);
    }
    this.isMobile = window.innerWidth < 992;
    this.breakpointObserver.observe([Breakpoints.XSmall]).subscribe((result) => {
      //let faqNavListKey = this.faqProgram != '' ? 'FAQ_Nav_List_Keys_' + this.faqProgram : 'FAQ_Nav_List_Keys';
      let faqNavListKey = 'FAQ_Nav_List_Keys_P360';
      this.faqNavKeys = this.resourceService
        .getPortalSetting(faqNavListKey)
        .Value.split(';')
        .filter((x) => x.length);
      this.faqNavKeys.forEach((item) => {
        if (item?.length) {
          this.faqNavMenu.push({
            sideNav: item,
            faqQues: this.resourceService.getPortalSetting('FAQ_Nav_List_' + item + '_Question').Value.split(';'),
            faqAns: this.resourceService.getPortalSetting('FAQ_Nav_List_' + item + '_Answer').Value.split(';'),
          });
        }
      });
      this.getFaqItems(this.faqNavKeys[0]);
    });
    window.scrollTo(0, 0);
  }

  getFaqNavLabel(key: string) {
    return this.resourceService.getViewLabel('FAQ_Nav_List_' + key);
  }

  getFaqIcon(key: string) {
    return this.resourceService.getViewLabel('FAQ_Nav_List_Icon_' + key);
  }

  getFaqItems(key: string) {
    this.selectedNavKey = key;
    this.selectedNavItem = 'FAQ_Nav_List_' + key;
    this.selectedNavItemTitle = this.resourceService.getViewLabel(this.selectedNavItem);
    let faqList = this.faqNavMenu.find((x) => x.sideNav == key);
    let manualListArray = [];
    let counter = 0;

    faqList.faqQues.forEach((faqItem) => {
      if (faqItem) {
        manualListArray.push([]);
        manualListArray[counter].questionKey = faqItem;
        counter++;
      }
    });

    counter = 0;
    faqList.faqAns.forEach((faqItem) => {
      if (faqItem) {
        manualListArray[counter].answerKey = faqItem;
        counter++;
      }
    });

    this.currentlyOpenedItemIndex = -1;
    this.faqListItems = manualListArray;
  }

  forcePageRefresh() {
    window.location.reload();
  }

  openASAPPChat() {
    const rnWindow = window as any;
    if (rnWindow.ReactNativeWebView) {
      const message = JSON.stringify({ action: 'openChat', args: {} });
      rnWindow.ReactNativeWebView.postMessage(message);
    }
    let hasP360MobilePolicy = this.storageService.getLocal<string>(`EprismContractsCount`) > '0';
    if (hasP360MobilePolicy) {
      this.chatHandler.openAsappChat();
    }
}

  handleKeyPress(event: any, key: string) {
    if (event.keyCode === 13) {
      this.getFaqItems(key);
    }
  }

  setOpened(itemIndex: number) {
    this.currentlyOpenedItemIndex = itemIndex;
  }

  setClosed(itemIndex: number) {
    if (this.currentlyOpenedItemIndex === itemIndex) {
      this.currentlyOpenedItemIndex = -1;
    }
  }

  getFaqItemQuestion(item: string) {
    const label = this.resourceService.getViewLabel(item) ?? '';
    return this.resourceService.transformContentData(label);
  }
}
